import React from "react";
import styled from "styled-components";
import PlatformDetails from "./platformDetails";

const Bottom = () => {
  const PlatformData = [
    { name: "Spotify", streams: "101600", type: "increase", percent: "2.50" },
    {
      name: "Apple Music",
      streams: "71600",
      type: "increase",
      percent: "4.50"
    },
    { name: "Deezer", streams: "30600", type: "decrease", percent: "3.00" },
    {
      name: "Amazon Music",
      streams: "64600",
      type: "increase",
      percent: "6.50"
    },
    {
      name: "Youtube Music",
      streams: "104600",
      type: "increase",
      percent: "5.50"
    }
  ];
  return (
    <Container>
      {PlatformData.map((data, i) => {
        return (
          <PlatformDetails
            width={`${100 / PlatformData.length}`}
            name={data.name}
            type={data.type}
            streams={data.streams}
            percent={data.percent}
          />
        );
      })}
    </Container>
  );
};

export default Bottom;

const Container = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
  @media only screen and (max-width: 769px) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));

    & > *:last-child {
      grid-column: span 2;
    }
  }
`;
